import { isNullUndefined } from "@/main/services/utils";
import React from "react";
import { useWatch } from "react-hook-form";

import LoadingComponent from "@/main/components/shared/loading/loadingComponent";
import { userIsAdmin, userIsBodyshop } from "@/main/services/utilsUser";
import ContactInfo, { IContactInfoState } from "@/main/components/shared/contactInfo";
import AddressInfo, { IAddressInfoState } from "@/main/components/shared/addressInfo";

import { usePreQuoteContext } from "../context";
import SectionInfo from "../sectionInfo";
import { Controls } from "@/main/services/constants/constantsControl";
import useKogControlElementId from "@/main/hooks/useKogControlElementId";

interface ISectionBodyshopProps {
	dataContacts: IContactInfoState[];
	setDataContacts: React.Dispatch<React.SetStateAction<IContactInfoState[]>>;
	dataAddress: IAddressInfoState[];
	setDataAddress: React.Dispatch<React.SetStateAction<IAddressInfoState[]>>;
}
function SectionBodyshop({ dataAddress, dataContacts, setDataAddress, setDataContacts }: ISectionBodyshopProps) {
	const CONTROL_BODYSHOP_SECTION = useKogControlElementId(Controls.IdBodyshopSession);

	const { preQuoteData, isLoadingBodyshop } = usePreQuoteContext();
	const watcherCountry = useWatch({
		name: "country",
		exact: true,
	});
	const watcherCompanyName = useWatch({
		name: "companyName",
		exact: true,
	});

	const showBodyshopPending =
		!isNullUndefined(preQuoteData) && preQuoteData.bodyshopPending && (userIsAdmin() || userIsBodyshop());

	if (!showBodyshopPending || !CONTROL_BODYSHOP_SECTION) return null;
	if (isLoadingBodyshop) return <LoadingComponent />;

	return (
		<>
			<SectionInfo />
			<ContactInfo
				dataContacts={dataContacts}
				setDataContacts={setDataContacts}
				typeCompany=""
				watcherCountry={watcherCountry}
				companyName={watcherCompanyName}
			/>
			<AddressInfo
				dataAddress={dataAddress}
				setDataAddress={setDataAddress}
				typeCompany=""
				watcherCountry={watcherCountry}
			/>
		</>
	);
}

export default SectionBodyshop;
